import { Box, Text, Image } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../constant";
import { useTranslation } from "react-i18next";

// 根據維護日索引取得對應的星期字串
const getWeekDayString = (dayIndex) => {
  const weekDays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  return weekDays[dayIndex] || "";
};

/**
 * @description: 維護通知內容組件，根據傳入的維護列表顯示相關信息
 * @param {Array} maintenanceList - 包含維護信息的列表
 * @return {JSX.Element}
 */
const MaintenanceContent = ({ maintenanceList }) => {
  const { t } = useTranslation();

  if (!maintenanceList || maintenanceList.length === 0) {
    return (
      <Box className="w-full text-center p-4">
        <Text>{t("announcement.no_maintenance")}</Text>
      </Box>
    );
  }

  return (
    <>
      <Text marginBottom={"1em"}>{t("announcement.maintenance_notice")}</Text>
      <Text fontWeight={"bold"}>{t("announcement.maintenance_schedule")}</Text>
      <Box overflow={"scroll"} height={"100%"} paddingBottom={"6em"}>
        {maintenanceList.map((item) => (
          <Box
            key={item.platform}
            bgImage={""}
            bgSize={"100% 100%"}
            padding={"20px"}
            display={"flex"}
            alignItems={"center"}
            gap={4}
          >
            <Box display={"flex"} alignItems={"center"} w={16} h={16}>
              <Image
                src={`${COMMON_WEB_PATH}/ds88platformIcon/${item.platformEnum}.png`}
              />
            </Box>
            <Box>
              <Text fontWeight="bold">{item.platform}</Text>
              <Text>{`${t(`announcement.${getWeekDayString(item.maintenance_day_of_week)}`)} ${t("announcement.routine_maintenance")}`}</Text>
              <Text sx={{ fontWeight: "bold" }}>
                {`${item.maintenanceStartTime} ~ ${item.maintenanceEndTime}`}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
};
export default MaintenanceContent;
